import { abeStylists } from 'actions/stylist/beSalonStylists.action';

import { SMS_CREDITS_PUSHER } from 'clientCommunications/constants';
import { GET_STYLISTS_FAILURE, GET_STYLISTS_REQUEST, GET_STYLISTS_SUCCESS } from 'onboarding/stylists/actions';
import {
  ENABLE_REMOTE_LOGIN_FAILURE,
  ENABLE_REMOTE_LOGIN_REQUEST,
  ENABLE_REMOTE_LOGIN_SUCCESS,
  GET_EMAIL_WITH_LOGIN_FAILURE,
  GET_EMAIL_WITH_LOGIN_REQUEST,
  GET_EMAIL_WITH_LOGIN_SUCCESS,
  REMOVE_ACCESS_FAILURE,
  REMOVE_ACCESS_REQUEST,
  REMOVE_ACCESS_SUCCESS,
  RESET_REMOVED_ACCESS,
} from 'salon/constants';

const initState = () => ({
  isFetching: false,
  errorMessage: null,
  authenticated: true,
  response: [],
  removeId: null,
  emailsWithLogin: [],
  removedAccess: false,
});

const stylistListReducer = (state = initState(), action) => {
  // NOTE: v1 will not have originalJson, that's a field on results from v3 fetches
  const { type, params, errorMessage, response, data, originalJson: rv3og } = action ?? {};

  if (!type) return state;

  switch (type) {
    case GET_STYLISTS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case abeStylists.AT.pass: // TODO: future replacement for GET_STYLISTS_SUCCESS
      return { ...state, response: rv3og, errorMessage: null };
    case GET_STYLISTS_SUCCESS:
      return { ...state, isFetching: false, response, errorMessage: null };
    case GET_STYLISTS_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case SMS_CREDITS_PUSHER:
      return { ...state, sms_credits_available: data.data.data.sms_credits_available };
    case ENABLE_REMOTE_LOGIN_REQUEST:
      return { ...state, isFetching: true };
    case ENABLE_REMOTE_LOGIN_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case ENABLE_REMOTE_LOGIN_SUCCESS:
      return { ...state, isFetching: false, stylistHasReceivedEmail: response };
    case GET_EMAIL_WITH_LOGIN_REQUEST:
      return { ...state, isFetching: true };
    case GET_EMAIL_WITH_LOGIN_FAILURE:
      return { ...state, isFetching: false, errorMessage };
    case GET_EMAIL_WITH_LOGIN_SUCCESS:
      return { ...state, isFetching: false, emailsWithLogin: response };
    case REMOVE_ACCESS_REQUEST:
      return { ...state, isFetching: true, removeId: params.userId, removedAccess: false };
    case REMOVE_ACCESS_FAILURE:
      return { ...state, isFetching: false, errorMessage, removedAccess: false };
    case REMOVE_ACCESS_SUCCESS: {
      const { emailsWithLogin, removeId } = state;
      const indx = emailsWithLogin.findIndex((email) => email.id === removeId);
      emailsWithLogin.splice(indx, 1);
      return { ...state, isFetching: false, emailsWithLogin, removedAccess: true };
    }
    case RESET_REMOVED_ACCESS:
      return { ...state, removedAccess: false };
    default:
      return state;
  }
};

export default stylistListReducer;
